import { render, staticRenderFns } from "./UnitSelectbox.vue?vue&type=template&id=60277647"
import script from "./UnitSelectbox.vue?vue&type=script&lang=js"
export * from "./UnitSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports